import actionBuilder, { copy, show } from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

const copyTemplate = (payload, silent = false) => {
  return copy(`${actionType}_COPY`, `${apiPath}/${payload?.data?.id}/copy`, { ...payload, silent });
};

const getEditUrl = (id) => {
  return show(actionType, `${apiPath}/${id}/edit`, {}, { action: 'GET_EDIT_URL' });
};

const actions = {
  ...actionBuilder({ apiPath, bulkActionType, actionType }),
  copyTemplate,
  getEditUrl,
};

export default actions;
